import { memo, ReactNode } from 'react'
import classNames from 'classnames'

import s from './Menu.module.less'

interface IProps {
  children?: ReactNode
  className?: string
  footer?: ReactNode
  header?: ReactNode
}

export const Menu = memo(function Menu({ header, children, className, footer }: IProps) {
  return (
    <div className={classNames(s.Menu, { [s.Menu_offset]: !header }, className)}>
      {header}
      {children}
      {footer && <div className={s.footer}>{footer}</div>}
    </div>
  )
})
